import CognitoUserEdit from './abstract/CognitoUserEdit'
import Config from '../../../Config'

class AdminUserEdit extends CognitoUserEdit {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.nameTitle = '氏名'
    this.apiUrl = Config.adminApiUrl.userManagement
    this.userRoleName = '事務局管理者'
    this.userRoleUrl = 'admin_user'
    this.userRole = 'admin'
  }
}

export default AdminUserEdit



// WEBPACK FOOTER //
// ./src/admin/pages/secure/AdminUserEdit.js